<template>
    <div>
        <div id="print" class="d-flex flex-wrap">
            <div id="printObj">
                <div v-for="item in items" v-bind:key="item.id" class="printPage">
                    <div class="headerDiv">
                        <label class="sithLabel">SITH</label>
                        <img class="logoImg" src="@/assets/images/logo_siemens_energy.png"/>
                    </div>
                    <div class="simpleInfoDiv">
                        <label class="contentLabel">项目号/Project No.</label><br/>
                        <label class="contentLabel">发货码/批次号</label><br/>
                    </div>
                    <div class="simpleValueDiv">
                        <div class="simpleInputDiv">
                            <input v-model="item.projectCode" class="simpleInput" type="text"/>
                        </div>
                        <div class="simpleInputDiv">
                            <input :value="formatDeliveryCodeAndBatch(item.deliverCode, item.batch)" class="simpleInput" type="text"/>
                        </div>
                    </div>
                    <div class="detailLabel">
                        <label class="textareaLabel">物料描述/Description.</label><br/>
                        <label class="contentLabel1">物料号/Material No.</label><br/>
                        <label class="contentLabel1">数量/Quantity.</label><br/>
                        <label class="contentLabel1">SO/WBS号.</label><br/>
                        <label class="contentLabel1">存储BIN位.</label><br/>
                    </div>
                    <div class="detailDiv">
                        <div class="textareaDiv">
                            <textarea :value="item.materialDesc" rows="3"
                                      @input="item.materialDesc = $event.target.value"></textarea>
                        </div>
                        <div class="detailInputDiv">
                            <input v-model="item.materielCode" class="detailInput" type="text"/>
                        </div>
                        <div class="detailInputDiv">
                            <input :value="getValue(item,'purchaseQuantity','materielUnit')" class="detailInput"
                                   type="text"/>
                        </div>
                        <div class="detailInputDiv">
                            <input :value="item.specialStockNumber" class="detailInput" type="text"/>
                        </div>
                        <div class="detailInputDiv">
                            <input :value="item.storageBin" class="detailInput"
                                   type="text"/>
                        </div>
                        <div class="qrCode">
                            <img :src="item.src" alt="图片找不到了。。。。"/><br/>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <el-button v-print="'#printObj'" class="print-btn ml-1" v-if="!isMobileDevice">桌面端打印标签</el-button>
            <el-button type="primary" class="print-btn ml-1" v-if="isMobileDevice" @click="openApp('?'+'json='+encodeURIComponent(JSON.stringify(items,function (key,value) {
                if(key =='src') {
                    return undefined;
                }
                return value;
            }))+'&printType=binDataPrint')"
            >移动端蓝牙打印标签
            </el-button>
            <el-button type="primary" class="print-btn ml-2" v-if="isMobileDevice" @click="downloadApp()">
                下载移动端最新app
            </el-button>
        </div>
    </div>

</template>

<script>

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";

const formatDeliveryCodeAndBatch = require("@/utils/formatDeliveryCodeAndBatch");

let timer;
export default {
    name: "SithMesInventoryBinStatusPrint",
    data: function () {
        return {
            type: 'pc',
            ua : window.navigator.userAgent.toLowerCase(),
            androidSchemeUrl:'siemens://sithmom:9999/print',
            iosSchemeUrl:'',
            androidDownloadUrl:'https://pan.baidu.com/s/1lvSudBwWCYpjTME1GlmBLA?pwd=5r18',
            iosDownloadUrl:'',
            picture: '',
            items: [],
        };
    },
    components: {},
    mixins: [emCommonListMixin, emCommonApiMixin],
    computed: {
        isMobileDevice() {
            return /iphone|ipad|ipod/.test(this.ua) || /android/.test(this.ua);
        },
    },
    methods: {
        formatDeliveryCodeAndBatch(deliverCode, batch) {
            return formatDeliveryCodeAndBatch(deliverCode, batch);
        },
        getMaterialQr(item) {
            let that = this;
            let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/getQrCode`;
            this.$_emApiMixin_post(_url, item).then((data) => {
                that.$set(item, 'src', data.data);
            });
        },
        convertUndefined(property) {
            if (property === undefined) return '';
            return property;
        },
        watchVisibility() {
            window.addEventListener('visibilitychange', () => {
                // 监听页面visibility
                if(document.hidden && timer != null) {
                    // 如果页面隐藏了，则表示唤起成功，这时候需要清除下载定时器
                    clearTimeout(timer)
                }
            })
        },
        getValue(item, property, poItem) {
            if (item[property] && item[poItem]) {
                return item[property] + '/' + item[poItem];
            }
            if (item[property]) {
                return item[property];
            }
            return '';
        },
        //判断是否为微信浏览器
        isWeiXin() {
            return this.ua.match(/MicroMessenger/i) == "micromessenger" || this.ua.match(/_SQ_/i) == "_sq_";
        },
        //打开app
        openApp(data) {
            if (/iphone|ipad|ipod/.test(this.ua)) {
                this.type = "ios";

            } else if (/android/.test(this.ua)) {
                this.type = "android";
            }
            if (!this.isWeiXin()) {
                switch (this.type) {
                    case "pc": {
                        break;
                    }
                    case "android": {
                        location.href = this.androidSchemeUrl + data;
                        let androidDownloadUrl = this.androidDownloadUrl;
                        timer = setTimeout(function () {
                            window.location.href = androidDownloadUrl;
                        }, 5000);
                        break;
                    }
                    case 'ios': {
                        location.href = this.iosSchemeUrl + data;
                        let iosDownloadUrl = this.iosDownloadUrl;
                        timer = setTimeout(function () {
                            window.location.href = iosDownloadUrl;
                        }, 5000);
                        break;
                    }
                    default: {
                        break;
                    }
                }
            }
        },
        downloadApp() {
            window.location.href = this.androidDownloadUrl;
        },
    },
    mounted() {
        this.items = this.$route.query;
        this.items.forEach((item) => {
            this.getMaterialQr(item);
        })
        this.watchVisibility();
    }
}
</script>

<style>

@page {
    size: 120mm 90mm !important;
}

@media print {
    .printPage {
        page-break-after: always;
        margin: 4px !important;
    }

    .printPage:last-child {
        page-break-after: auto;
    }

    input {
        border: none;
    }

    textarea {
        border: none;
    }

    #printObj {
        height: auto;
        width: 580px;
        margin: 2px !important;
    }

    .print-btn {
        visibility: hidden;
    }


}

.print-btn{
    height: min-content;
    margin-top: 80px !important;
}

.printPage {
    height: 370px;
}

#printObj {
    height: auto;
    width: 580px;
    margin: 80px;
}

.simpleInput {
    height: 25px;
    width: 100%;
    font-size: 19px;
    line-height: 35px;
    margin-left: 2px;
}

.detailInput {
    height: 38px;
    width: 96%;
    font-size: 17px;
    line-height: 38px;
    margin-left: 2px;
}

.contentLabel1 {
    font-size: 19px;
    height: 40px;
    display: inline-block;
    line-height: 40px;
    width: 100%;
    text-align: left;
}

.contentLabel {
    font-size: 19px;
    height: 35px;
    display: inline-block;
    line-height: 35px;
    width: 100%;
    text-align: left;
}

.qrCode {
    width: 140px;
    height: 140px;
    margin-top: -105px;
    float: left;
}

.qrCode img {
    width: 160px;
    height: 160px;
    margin-top: -15px;
}

.logoImg {
    margin-left: 340px;
    width: 85px;
    height: 38px;
}

.sithLabel {
    float: left;
    font-size: 20px;
}

.headerDiv {
    width: 100%;
    height: 40px;
}

.simpleInfoDiv {
    border-style: solid solid solid none;
    width: 200px !important;
    height: 70px;
    float: left;
    border-width: thin;
}

.simpleValueDiv {
    border-style: solid none solid none;
    border-width: thin;
    width: 370px;
    height: 70px;
    float: left;
}

.simpleInputDiv {
    width: 100%;
    height: 35px;
    float: left;
    line-height: 35px;
}

.detailLabel {
    border-style: solid solid solid none;
    border-width: thin;
    width: 200px;
    height: 230px;
    float: left;
    margin-top: 15px;
    text-align: left;
}

.textareaLabel {
    height: 60px;
    line-height: 60px;
    font-size: 19px;
    width: 100%;
    text-align: left;
}

.detailDiv {
    border-style: solid none solid none;
    border-width: thin;
    width: 370px;
    height: 230px;
    float: left;
    margin-top: 15px;
}

.textareaDiv {
    width: 100%;
    height: 60px;
    float: left;
    line-height: 60px;
}

textarea {
    word-break: break-all;
    width: 359px;
    height: 55px;
    font-size: 16px !important;
    margin-left: 2px !important;
    margin-top: 2px !important;
    line-height: 16px !important;
}

.detailInputDiv {
    width: 200px;
    height: 40px;
    float: left;
    line-height: 40px;
}

.shortInput {
    width: 200px;
    float: left;
}

label {
    margin-bottom: 0 !important;
}

</style>
